import { z } from 'zod';
import { PAGINATION_PAGE_SIZE_DEFAULT } from '~/constants';

import { CONTRACT_IMPORT_JOB_STATUS } from '../constants';

// Re-export shared validations used by this hook
export {
  zodContractImportJobSummarySchema,
  zodPaginatedContractImportJobsResponseSchema,
} from '../validations';

export const zodContractImportJobsQueryParamsSchema = z.object({
  includeDone: z.boolean().optional().default(false),
  limit: z.number().int().min(1).max(200).default(PAGINATION_PAGE_SIZE_DEFAULT),
  offset: z.number().int().min(0).default(0),
  status: z
    .array(z.enum(CONTRACT_IMPORT_JOB_STATUS))
    .optional()
    .catch(undefined),
});
